<template>
  <CardSection :loading="isSavableStateLoading" :error="majorError">
    <template #header>
      Edit Template Category {{ selectedCategory ? `- ${selectedCategory.category_name}` : '' }}
    </template>
    <template #body>
      <SubSection sub-section-heading="Advanced" :sub-section-nav="subSectionNav">
        <template #body>
          <template v-if="!isSavableStateLoading && selectedCategory">
            <div class="bordered-section">
              <TemplateCategoryEnableToggle
                :category-disabled-at="selectedCategory.disabled_at"
                :category-id="categoryId"
                @load-category="loadCategory" />
            </div>
          </template>
        </template>
      </SubSection>
    </template>
  </CardSection>
</template>

<script>
import CardSection from "@/src/components/shared/CardSection.vue";
import SubSection from "@/src/components/shared/SubSection.vue";
import { useTemplateStore } from '@/src/stores/template';
import { pageMixin } from "@/src/mixins/pageMixin";
import { templateCategorySubSectionNavMixin } from "@/src/components/admin-area/templates/templateCategorySubSectionNavMixin";
import { savableStateMixin } from "@/src/mixins/savableStateMixin";
import TemplateCategoryEnableToggle from "@/src/components/admin-area/templates/templateCategoryEnableToggle.vue";

export default {
  components: {
    CardSection,
    SubSection,
    TemplateCategoryEnableToggle
  },
  mixins: [ pageMixin, savableStateMixin, templateCategorySubSectionNavMixin ],
  setup() {
    const templateStore = useTemplateStore();
    return {
      templateStore
    }
  },
  data() {
    return {
      selectedCategory: null,
      categoryId: this.$route.params.id
    }
  },
  async mounted() {
    try {
      this.setSavableStateLoading();
      this.loadCategory(await this.templateStore.loadCategory(this.$route.params.id));
      this.setSavableStateIdle();
    } catch(error) {
      this.handleMajorError(error);
    }
  },
  methods: {
    loadCategory(category) {
      this.selectedCategory = {
        id: category.id,
        category_name: category.category_name,
        disabled_at: category.disabled_at
      }
    }
  }
}
</script>
